// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5cd13276","455":"7eb4a684","977":"eb31ae6f"}[chunkId] + ".chunk.js";
};